import { useMutation, useQueryClient } from '@tanstack/react-query';

import { engagementResourcesService } from '../services';

import { engagementResourcesKeys } from './useEngagementResources';

export function usePublishResource(id: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: () => engagementResourcesService.publish(id),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: engagementResourcesKeys.lists() });
      void qc.invalidateQueries({ queryKey: engagementResourcesKeys.detail(id) });
    },
  });
}
